import React, { Component } from 'react';
import { Paragraph, Text, Title } from 'common-components/typography';
import { dispatch, IRootDispatch, IRootState, state } from 'stores/rematch/root-store';
import { connect } from 'react-redux';
import * as H from 'history';
import EditInvoiceModal from 'views/account-management/components/FundingAndPaymentModals/EditInvoiceModal';
import EditNDISModal from 'views/account-management/components/FundingAndPaymentModals/EditNDISModal';
import { australianFlag } from 'assets/Icons/country-flags';
import EditVCPModal from 'views/account-management/components/FundingAndPaymentModals/EditVCPModal';
import _ from 'lodash';
import { PaymentSourceType } from 'utilities/enum-utils';
import ConfigCard from './components/ConfigCard';

interface IFundingAndPaymentViewProps {
  doFetchCompanyFundingAndPayment: typeof dispatch.companyStore.doFetchCompanyFundingAndPayment;
  doFetchCompanyLite: typeof dispatch.companyStore.doFetchCompanyLite;
  companyFundingAndPayment: typeof state.companyStore.companyFundingAndPayment;
  portalUser: typeof state.authStore.portalUser;
  history: H.History;
}

interface IFundingAndPaymentViewState {
  isLoading: boolean;
  isEditInvoiceConfigOpen: boolean;
  isEditNDISConfigOpen: boolean;
  isEditVCPConfigOpen: boolean;
}

class FundingAndPaymentView extends Component<IFundingAndPaymentViewProps, IFundingAndPaymentViewState> {
  state = {
    isLoading: true,
    isEditInvoiceConfigOpen: false,
    isEditNDISConfigOpen: false,
    isEditVCPConfigOpen: false,
  };

  private _goToLandingPage = () => {
    this.props.history.push('/account/landing');
  };

  private _openEditInvoiceConfig = () => {
    this.setState({ isEditInvoiceConfigOpen: true });
  };

  private _closeEditInvoiceConfig = () => {
    this.setState({ isEditInvoiceConfigOpen: false });
  };

  private _openEditNDISConfig = () => {
    this.setState({ isEditNDISConfigOpen: true });
  };

  private _closeEditNDISConfig = () => {
    this.setState({ isEditNDISConfigOpen: false });
  };

  private _openEditVCPConfig = () => {
    this.setState({ isEditVCPConfigOpen: true });
  };

  private _closeEditVCPConfig = () => {
    this.setState({ isEditVCPConfigOpen: false });
  };

  componentDidMount = async () => {
    await this.props.doFetchCompanyFundingAndPayment({});
    this.setState({ isLoading: false });
  };

  render() {
    const VCPConfig = this.props.companyFundingAndPayment
      ? _.find(
          this.props.companyFundingAndPayment.paymentSources,
          (funding) => funding.paymentSourceType === PaymentSourceType.VCP,
        )
      : null;

    return (
      <>
        <EditInvoiceModal
          isOpen={this.state.isEditInvoiceConfigOpen}
          onClose={this._closeEditInvoiceConfig}
          isLoading={this.state.isLoading}
        />
        <EditNDISModal isOpen={this.state.isEditNDISConfigOpen} onClose={this._closeEditNDISConfig} />
        <EditVCPModal isOpen={this.state.isEditVCPConfigOpen} onClose={this._closeEditVCPConfig} />
        <div className={'pb-x4-large'}>
          <div className='mb-medium'>
            <Title level={3} weight='regular' className='mv-none'>
              <span className={'cursor-pointer text-color-blue-action'} onClick={this._goToLandingPage}>
                {'Account >'}
              </span>{' '}
              Funding and Payment
            </Title>
          </div>
          <Paragraph>
            Configure funding bodies and customise invoices to be automatically generated from GoodHuman.
          </Paragraph>
          <div className='mt-x-large bordered-bottom border-standard-gray'>
            <ConfigCard
              title='Invoice'
              description='Generate an invoice containing payment terms.'
              actionLabelText='Configure'
              onClick={this._openEditInvoiceConfig}
            />
            <ConfigCard
              title='National Disability Insurance Scheme (NDIS)'
              subtitle={
                <>
                  <img src={australianFlag} height={'8px'} alt={'Australian National Flag'} className={'mr-x-small'} />
                  <Text size={'regular'}>Australia</Text>
                </>
              }
              description='The National Insurance Scheme is a scheme of the Australian Government that funds costs associated with disability.'
              actionLabelText='ON'
              actionLabelColor='blue-action'
              onClick={this._openEditNDISConfig}
            />
            {VCPConfig && (
              <ConfigCard
                title="Vulnerable Children's Program (VCP)"
                subtitle={
                  <>
                    <img
                      src={australianFlag}
                      height={'8px'}
                      alt={'Australian National Flag'}
                      className={'mr-x-small'}
                    />
                    <Text size={'regular'}>Australia</Text>
                  </>
                }
                description="The Vulnerable Children's Program is an Australian Government scheme aimed at supporting at-risk children in the community."
                actionLabelText={VCPConfig.paymentSourceConfiguration.vcpEnabled ? 'ON' : 'OFF'}
                actionLabelColor='blue-action'
                isActionLabelLoading={VCPConfig.paymentSourceConfiguration?.vcpEnabled == null}
                onClick={this._openEditVCPConfig}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapState = (state: IRootState) => ({
  companyFundingAndPayment: state.companyStore.companyFundingAndPayment,
  portalUser: state.authStore.portalUser,
});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doFetchCompanyFundingAndPayment: dispatch.companyStore.doFetchCompanyFundingAndPayment,
  doFetchCompanyLite: dispatch.companyStore.doFetchCompanyLite,
});

export default connect(mapState, mapDispatch)(FundingAndPaymentView);
